import { type ReactNode, useState } from 'react';

import { useKeycloakContext } from '@wf/keycloak-axios-provider';
import { localStorageService } from '@wf/sw-ui-kit';

import ItemsContext from '../ItemsContext';

import { TableMode } from '../../../constants';

import { getPreferedItemsModeKey } from '../../../helpers';

interface IItemsContextProviderProps {
  children: ReactNode;
}

function ItemsContextProvider({ children }: IItemsContextProviderProps) {
  const { getUserData } = useKeycloakContext();
  const { username }: IUserInfo = getUserData();

  const key = getPreferedItemsModeKey(username);
  const [itemsMode, setItemsMode] = useState<TableMode>(() => {
    const preferredMode = localStorageService.get(key) as TableMode;

    if (
      preferredMode &&
      typeof preferredMode === 'string' &&
      [TableMode.List, TableMode.Table].includes(preferredMode)
    ) {
      return preferredMode;
    } else {
      return TableMode.List;
    }
  });

  const handleModeChange = (mode: TableMode) => {
    if (mode === itemsMode) {
      return;
    }

    setItemsMode(mode);
    localStorageService.set(key, mode);
  };

  return (
    <ItemsContext.Provider value={{ itemsMode, setItemsMode: handleModeChange }}>{children}</ItemsContext.Provider>
  );
}

export default ItemsContextProvider;
